import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfigService } from '@fmnts/api';
import { Observable } from 'rxjs';

import {
  UnsubscribeForm,
  UnsubscribeFormAdapter,
} from '../model/unsubscribe-form';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribeFormApi {
  private static readonly rootUrl = '/api/next/unsubscribe';

  private unsubscribeFormAdapter = new UnsubscribeFormAdapter();

  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfigService,
  ) {}

  /**
   * @param hash Hash that identifies the donation
   *
   * @returns
   * Observable that emits with the unsubscribe form
   * for the given `hash`.
   */
  public getForm(hash: string): Observable<UnsubscribeForm> {
    const url = this.apiConfig.buildApiUrl([UnsubscribeFormApi.rootUrl, hash]);

    return this.http.get<UnsubscribeForm>(url);
  }

  /**
   * Unsubscribes from a donation by using the
   * given `hash` and `data`
   *
   * @param hash Hash that identifies the donation
   * @param data Prepared form data
   *
   * @returns
   * An observable that emits with the result from the
   * unsubscribe API request
   */
  public unsubscribe(hash: string, data: Record<string, any>): Observable<any> {
    const url = this.apiConfig.buildApiUrl([UnsubscribeFormApi.rootUrl]);

    return this.http.post(url, data);
  }
}
